<template>
  <div>
    <div class="chart-container">
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <span>{{$t('Segment Analysis')}}</span>
        </div>
        <div class="main-header-right">
          <button @click="print"><span>{{$t('print')}}</span></button>
          <button class="set" @click="open"><span>{{$t('set')}}</span></button>
          <p>{{$t('period')}}:<span class="time">{{timeRange2}}</span></p>
        </div>
      </div>
      <hr class="small-hr spe-hr">
      <div element-loading-text="Loading" v-loading.fullscreen.lock="loading" >
      <el-col :span="24">
        <div id="chart1_1" class="graph"></div>
      </el-col>
      </div>
      <div class="bolCount">
        <p>{{$t('# of Boluses')}}</p>
        <table class="countLabel">
          <tr id="count">
            <td v-for="i in 48"></td>
          </tr>
        </table>
      </div>
      <el-col :span="24">
        <div id="chart1_3" class="graph"></div>
      </el-col>
      <el-col :span="24">
        <div id="chart1_2" class="graph"></div>
      </el-col>
    </div>
    <!--时间选择对话框-->
    <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize  id="dialog-form2" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('setPeriod')}}</span>
        <img src="../../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div class="duration" >
          <span>{{$t('duration')}}</span>
          <select id="duration"  @change = "timeChange" v-model="timeType">
            <option>{{$t('7 days')}}</option>
            <option>{{$t('14 days')}}</option>
            <option>{{$t('30 days')}}</option>
            <option>{{$t('90 days')}}</option>
            <option>{{$t('Customize')}}</option>
          </select>
        </div>
        <div class="time-range" :class="{'zh2':!isEn}">
          <p>{{$t('From')}}</p>
          <div class="date">
            <span v-show="!custo">{{staTime}}</span>
            <el-date-picker v-model="value4" type="date"  :editable=false  :picker-options="pickerOptions" v-show="custo"
                        :clearable=false  :placeholder="staTime"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <p>{{$t('To')}}</p>
          <div class="block">
            <el-date-picker v-model="value3" type="date"  :editable=false  :picker-options="pickerOptions"
                            @change="timeChange"     :clearable=false  :placeholder="endTime"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
        </div>
        <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button @click="dateApply">{{$t('applyM')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import format from '@/lib/format'
  import B64 from '../../auth/base64'
  export default {
    data() {
      return {
        isA:false,value2:'',value3:'', uid:0, st:0,et:0, basal:[],bolus:[],timeSection:[],
        staTime:'',endTime:'',timeRange2:'',isMg:'',isEn:'',loading:false,basalMax:5,
        custo:false,value4:'',timeType:'',update_time:'',

        ts:[[],[]], sg1:[],sgHalf:[],target_high:'',target_low:'',bolus1:[],bolCount:[], sg:[],
        typeChooseVisible:false,dialogSize:'tiny',sgMax:25,bolusMax:20,
        sgDate:['00:00','00:30','01:00','01:30','02:00','02:30','03:00','03:30','04:00','04:30','05:00','05:30','06:00','06:30','07:00','07:30','08:00','08:30','09:00','09:30','10:00','10:30',
          '11:00','11:30','12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30','17:00','17:30','18:00','18:30','19:00','19:30','20:00','20:30','21:00','21:30','22:00','22:30','23:00','23:30'],
        sgDate1:['00:00','','01:00','','02:00','','03:00','','04:00','','05:00','','06:00','','07:00','','08:00','','09:00','','10:00','',
          '11:00','','12:00','','13:00','','14:00','','15:00','','16:00','','17:00','','18:00','','19:00','','20:00','','21:00','','22:00','','23:00',''],
        pickerOptions:{
          disabledDate(time){
            let t1=time.getTime();
            let d2=new Date();
            let t2=d2.getTime();
            //return (t1>t2 || (d2.getYear()-time.getYear())>2 );
            return (t1>t2 || t1<(t2-730*86400*1000));
          }
        },

        date:['','','','','',''],
        textStyle: {
          color: '#282828',
          fontWeight: 'normal',
          fontSize: '14',
          fontFamily: 'SFUIText-Regular'
        },
        titlePadding: [0, 0, 8, 33],
        grid:{x: '4%', y: '16%', width: '90%', height: '75%',},legend1Right:'',legend2Right:'',
        sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0']
          , ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
        dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "",
          "", "18:00", "", "", "21:00", "", "", "24:00",],
        yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},
        axisPointer:{
          type:'line',
          axis:'x',
          lineStyle:{color:'#777',}
        },
      }
    },
    methods: {
      drawChart1_1() {
        let that = this;
        this.chart1_1= echarts.init(document.getElementById('chart1_1'));
        this.chart1_1.setOption({
          title: {
            text:(this.isMg)? this.$t('Sensor Glucose Profile')+' (mg/dL)':this.$t('Sensor Glucose Profile')+' (mmol/L)',
            textStyle: this.textStyle,
            padding: this.titlePadding,
          },
          xAxis: [{
            type:'category',
            data:this.sgDate,
            axisLabel:{show:false,interval:0,},
            axisLine: {lineStyle: {color: '#ccc'}},
          }],
          yAxis: [
            {
              type: 'value',
              min:0,
              max:this.sgMax,
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
          },
            {
            type: 'value',
            min:0,
            max:this.sgMax,
            axisLabel:{show:false},
            axisLine: {lineStyle: {color: '#ccc'}},
            boundaryGap: false,
            axisTick: {length: 0},
          }
          ],
          tooltip:{
            trigger:'axis',
            confine:true,
            axisPointer:this.axisPointer,
            backgroundColor:'#333',
            formatter:function(params){
              let tip = that.tooltipFormat(params,that);
              return tip;
            },
          },
          grid: this.grid,
          legend:{
            selectedMode:false,
            itemWidth:50,
            itemHeight:110,
            right:this.legend1Right,
            top:'middle',
            data:[{ name:'25%',icon:'image://static/segLegend/legend1.png'}],
            textStyle:{color:'rgba(0,0,0,0)'}
          },
          series: [
            {
              name:'10%',
              type: 'bar',
              barWidth:'60%',
              stack:'sg',
              data:this.sg1[0],
              itemStyle: {
                normal: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)'
                },
                emphasis: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)'
                }
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.target_low*18:this.target_low}],
                symbol:['circle','circle'],
                silent:true,
                symbolSize: 1,
                lineStyle: {normal: {
                  color: '#2cd200',
                  type: 'solid',
                }},
                label:{normal:{show:false}},
              },
              markArea: {
                data: [
                  [{yAxis: (this.isMg)?this.target_low*18:this.target_low}, { yAxis:(this.isMg)?this.target_high*18:this.target_high}]
                ],
                tooltip:{show:false},
                itemStyle: {
                  normal: {
                    color: 'rgba(211,255,213,0.6)',
                  }
                }
              },
            },
            {
              name:'25%',
              type: 'bar',
              stack:'sg',
              data:this.sg1[1],
              itemStyle: {
                normal: {
                  barBorderRadius: [0, 0, 20, 20],
                  color: '#a2ebff',
                },
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.target_high*18:this.target_high}],
                symbol:['circle','circle'],
                silent:true,
                symbolSize: 1,
                lineStyle: {normal: {
                  color: '#2cd200',
                  type: 'solid',
                }},
                label:{normal:{show:false}},
              },
            },
            {
              name:'75%',
              type: 'bar',
              stack:'sg',
              data:this.sg1[2],
              itemStyle: {
                normal: {
                  color: '#00ceef',
                },

              },
            },
            {
              name:'90%',
              type: 'bar',
              stack:'sg',
              data:this.sg1[3],
              itemStyle: {
                normal: {
                  barBorderRadius:[20,20,0,0],
                  color:'#a2ebff',
                },

              },
            },
            {
              type:'line',
              data:this.sgHalf,
              itemStyle: {normal: {
                color:'transparent',
                borderColor:'#0095ff',
                borderWidth:1,
              }},
              lineStyle:{normal:{
                color:'#e89b00',
                width:1,
              }},
              symbol:'diamond',
              symbolSize:4,
            },
          ],
        });
      },
      drawChart1_3() {
        let that = this;
        this.chart1_3 = echarts.init(document.getElementById('chart1_3'));
        this.chart1_3.setOption({
          title: [
            {
             // text: 'Bolus Insulin (U)',
            //  textStyle: this.textStyle,
            //  padding: this.titlePadding,
             // text:'# of Bolus'
            },
          ],
          tooltip:{
            trigger:'axis',
            confine:true,
            axisPointer:this.axisPointer,
            backgroundColor:'#333',
            formatter:function(params){
             let tip = that.tooltipFormat2(params[0],that);
              return tip;
            },
          },
          xAxis: [{
            type:'category',
            data:this.sgDate,
            axisLabel:{ show:false,interval:0,},
            axisLine: {lineStyle: {color: '#ccc'}},
          }],
          legend:{
            selectedMode:false,
            itemWidth:50,
            itemHeight:118,
            right:this.legend2Right,
            top:'middle',
            data:[{ name:'bolus',icon:'image://static/segLegend/legend2.png'}],
            textStyle:{color:'rgba(0,0,0,0)'}
          },
          yAxis: [
            {
              type: 'value',
              axisLabel: this.yAxisLabel,
              axisLine:{lineStyle:{color:'#ccc'}},
              min:0,
              max:this.bolusMax,
              boundaryGap: false,
              splitLine: {show: false,},
              axisTick: {length: 0},
              name: this.$t('Bolus Insulin')+' '+this.$t('ins_unit'),
              nameTextStyle:{
                color: '#000',
                fontWeight: 'normal',
                fontSize: '13',
                fontFamily: 'SFUIText-Regular'
              },
              nameLocation:'middle',
              nameGap:25,
            },
            {
              type: 'value',
              axisLabel: {show:false},
              axisLine:{lineStyle:{color:'#ccc'}},
              min:0,
              max:this.bolusMax,
              axisTick: {length: 0},
            },
          ],
          grid:this.grid,
          series: [
            {
              name:'bolus',
              type:'boxplot',
              data:this.bolus1,
              hoverAnimation:false,
              boxWidth:['30%','35%'],
              itemStyle: {normal: {borderColor:'#0095ff',},},
            },
          ]
        });
      },
      drawChart1_2() {
        let that = this;
        let basal_unit=this.$t('basal_unit');
        let basal_unit2=this.$t('basal_unit2');
        this.chart1_2 = echarts.init(document.getElementById('chart1_2'));
        this.chart1_2.setOption({
          title: [
            {
              text: this.update_time,
              textStyle:this.textStyle,
              padding: [5, 0, 8, 50],
            },
          ],
          tooltip:{
            trigger:'axis',
            axisPointer:{type:'line', lineStyle:{color:'#333',}},
            backgroundColor:'#333',
            formatter:function(params){
               // console.log(params);
              let icon  =" <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
              let timeDetail ='',value ='';
              params.map(function (e) {
             //   let date = e.value[0];
              //  let time = format.formatterDate5(date);
              //  timeDetail = time[0]+':'+time[1]+'<br>';
                timeDetail =e.value[2]+'<br>';
                value = e.value[1];
              });
              return  timeDetail+icon+'Basal: '+value+basal_unit2;
            },
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.ts[0][0]*1000),
            max:new Date(this.ts[0][1]*1000),
            interlval:0,
            axisLabel:{
              margin: 10, textStyle: {color: '#282828', baseline: 'middle'} ,
              formatter:function (value,index) {
                let H = that.getXlabel(value,index);
                return H;
              }
            },
            axisLine: {lineStyle: {color: '#ccc'}},
            splitNumber: 24,
          }],
          yAxis: [
            {
              type:'value',
              boundaryGap: false,
              min:0,
              max:this.basalMax,
              splitNumber:5,
              axisTick: {length: 0},
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              name:this.$t('Basal Pattern')+' '+this.$t('basal_unit'),
              nameTextStyle:{
                color: '#000',
                fontWeight: 'normal',
                fontSize: '13',
                fontFamily: 'SFUIText-Regular'
              },
              nameLocation:'middle',
              nameGap:25,
            }
          ],
          grid: this.grid,
          series: [
            {
              type: 'line',
              name:'Basal',
              data:this.basal,
              // step:'middle',
              itemStyle: {normal: {color: '#00ff40'}},
              symbolSize:2,
            },
          ]
        });
      },

      getXlabel(value,index){
         let H = new Date(value).getHours();
         if(index<24){
           H = H<10 ? ('0'+H+':00' ): H+':00';
           return  H;
         }else{
           return '24:00';
         }
       },
      tooltipFormat(params,context){
         //console.log(params);
        let tipArray = [0,0,0,0,0],tip = '',time ='', data = context.sg1;
        let icon1  =" <div style='background: #00ceef;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon2  =" <div style='background: #0095ff;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        //获取时间
        if(params[0]){
          time = context.getTimeRange(params[0].name);
        }
        tip  = tip+time+'<br>';
        params.map(function (e,i) {
            let value = e.value;
            if(value!==undefined){
              let seriesIndex = e.seriesIndex,dataIndex =  e.dataIndex;
              if(seriesIndex===0){
                let realData = (context.isMg)?data[0][dataIndex]:data[0][dataIndex].toFixed(1);
                tipArray[4] =icon1+'10% : '+' '+realData;
              }
              if(seriesIndex===1){
                let realData  = data[0][dataIndex]+data[1][dataIndex];
                realData = (context.isMg)?realData:realData.toFixed(1);
                tipArray[3] =icon2+'25% : '+' '+realData;
              }
              if(seriesIndex===4){
                let realData = (context.isMg)?value:value.toFixed(1);
                tipArray[2] =icon2+'50% : '+' '+realData;
              }
              if(seriesIndex===2){
                let realData  = data[0][dataIndex]+data[1][dataIndex]+data[2][dataIndex];
                realData = (context.isMg)?realData:realData.toFixed(1);
                tipArray[1] =icon2+'75% : '+' '+realData;
              }
              if(seriesIndex===3){
                let realData  = data[0][dataIndex]+data[1][dataIndex]+data[2][dataIndex]+data[3][dataIndex];
                realData = (context.isMg)?realData:realData.toFixed(1);
                tipArray[0] =icon1+'90% : '+' '+realData;
              }
            }
        });
        tipArray.map(function (e,i) {
          if(e){
            tip = tip+e+'<br>';
          }
        });
        return tip;
      },
      tooltipFormat2(params,context){
        let index = params.seriesIndex,name = params.name,tip='',value = params.value ;
        if(index===0&&value[1]){
          let time = context.getTimeRange(name);
          let tip1 = ' - '+'10%'+' : '+value[1]+'<br>';
          let tip2 = ' - '+'25%'+' : '+value[2]+'<br>';
          let tip3 = ' - '+'50%'+' : '+value[3]+'<br>';
          let tip4 = ' - '+'75%'+' : '+value[4]+'<br>';
          let tip5 = ' - '+'90%'+' : '+value[5]+'<br>';
          tip= time+'<br>'+ tip5+tip4+tip3+tip2+tip1;
        }
        return tip;
      },
      getTimeRange(val){
        let time = '',t1  =val.split(':');
        if(t1[1]==='00'){
          time =  t1[0]+':00'+' - '+t1[0]+':30';
        }else{
          let t2  = parseInt(t1[0])+1;
          t2 = (t2<10)?('0'+t2):t2;
          time =  t1[0]+':30'+' - '+t2+':00';
        }
        return time;
      },

      drawCharts() {
        this.initCount();
        let timer = setTimeout(this.showCount,500);
        this.drawChart1_1();
        this.drawChart1_3();
        this.drawChart1_2();
      },
      chartsDispose(){
        this.chart1_1.dispose();
        this.chart1_2.dispose();
        this.chart1_3.dispose();
      },
      handleResize(){
        let win = window.innerWidth;
        let scale = (win<1500)?0.91:0.62;
        const chartWidth = win * scale * 0.98 * 0.94 + 'px';
        let chart1_1 = document.getElementById('chart1_1');
        let chart1_2 = document.getElementById('chart1_2');
        let chart1_3 = document.getElementById('chart1_3');
        if(chart1_3){
          chart1_1.style.width = chartWidth;
          chart1_2.style.width = chartWidth;
          chart1_3.style.width = chartWidth;
        }
      },

      showCount(){
        let count =this.bolCount,length=this.bolCount.length;
        let tr = document.getElementById('count');
       // console.log(count)
        for(let i=0;i<length;i++){
          let td = tr.getElementsByTagName('td')[count[i][0]];
          td.innerHTML = count[i][1];
        }
      },
      initCount(){
        let tr = document.getElementById('count');
        let td = tr.getElementsByTagName('td');
        for(let i=0;i<td.length;i++){
          td[i].innerHTML = '';
        }

      },

      getData(){
        this.ts = auth.getTs(this.st,this.et);
        //console.log(this.ts);
        let param = {
          sg:{ts:this.ts},
          basal:{ts:this.ts},
          bolus:{ts:this.ts},
          event:{ts:this.ts},
          custom:{
            usemode:'sa',
            ts:[this.st,this.et]
          }
        };
        /*let that=this;
        auth.getDataMap(this, this.uid, function(res){
          if (0!=res.error) {
            return;
          }
          var end_time=(res.end.cgms > res.end.pump)?res.end.cgms:res.end.pump;
          //console.log(param)
          //var ts_size=param.ts.length;
          //var time_offset=0;
          var cur_end=param.custom.ts[1];
          console.log(cur_end + ', '+end_time);
          for (var d=0; d<3000;d++) {
            if(cur_end>end_time) {
              cur_end -= 24*3600;
            } else {
              break;
            }
          }
          //console.log(d)
          //if (d)
          //  d -= 1;
          var sg_ts=param.sg.ts;
          var ts_size=sg_ts.length;
          for (var i=0; i<ts_size; i++) {
            sg_ts[i][0] -= 24*3600*d;
            sg_ts[i][1] -= 24*3600*d;
          }
          param.sg.ts=sg_ts;
          param.sg.basal=sg_ts;
          param.sg.bolus=sg_ts;
          param.sg.event=sg_ts;
          param.custom.ts[0] -= 24*3600*d;
          param.custom.ts[1] -= 24*3600*d;

          that.st=param.custom.ts[0];
          that.et=param.custom.ts[1];
          that.getDate();
          //console.log(that.timeRange2)
          auth.getSegment(that,that.uid,param);

        })*/
        auth.getSegment(this,this.uid,param);
        if(this.dayNum>7){
          this.openFullScreen();
        }
      },
      open(){
        this.typeChooseVisible=true;
        this.ckeckType();
      },
      ckeckType(){
        if(!this.custo){
          if(this.dayNum===7){ this.timeType = this.$t('7 days')}
          else if(this.dayNum===14){ this.timeType = this.$t('14 days')}
          else if(this.dayNum===30){ this.timeType = this.$t('30 days')}
          else if(this.dayNum===90){ this.timeType = this.$t('90 days')}
          else{this.timeType = this.$t('Customize')}
        }else{
            this.timeType = this.$t('Customize');
        }
      },
      cancel(){
        this.typeChooseVisible=false;
      },
      dateApply(){
        if(!this.value3){
          let t = this.endTime.split('-');
          this.et = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
        }else{
          this.et = this.value3.getTime()/1000;
        }
        let duration= document.getElementById('duration').value;
        if(duration===this.$t('7 days')){this.dayNum = 7;}
        if(duration===this.$t('14 days')){this.dayNum = 14;}
        if(duration===this.$t('30 days')){this.dayNum = 30;}
        if(duration===this.$t('90 days')){this.dayNum = 90;}
        if(duration===this.$t('Customize')){
            if(this.value4){
              let t = this.value4.getTime()/1000;
              this.dayNum = (this.et-t)/86400+1;
              if(this.dayNum<0||this.dayNum>90){
                this.$message.error('Segment Analysis Report Should Be 1-90 Days!');
                this.dayNum = 7;
              }
            }else{
              this.dayNum = 7;
            }
        }
        this.st = this.et - 86400*(this.dayNum-1);
        sessionStorage.setItem('st7',this.st);
        sessionStorage.setItem('et7',this.et);
        //this.ckeckType();
        this.getDate();
        this.getData();
        this.typeChooseVisible=false;
      },
      getDate(){
        this.date = [];
        for(let i=0;i<this.dayNum;i++){
          let day = this.st+i*86400;
          let time = format.formatterDate4(day);
          let weeks =  format.formatterDay(this,day);
          this.date[i] =time+' '+weeks;
        }
        this.timeRange2 = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.st+(this.dayNum-1)*86400);
        this.staTime = format.formatterDate4(this.st);
        this.endTime = format.formatterDate4(this.et);
      },
      //切换时间类型
      timeChange(){
        if(!this.value3){
          let t = this.endTime.split('-');
          this.et = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
        }else{
          this.et = this.value3.getTime()/1000;
        }
        let duration= document.getElementById('duration').value;
        if(duration===this.$t('7 days')){this.dayNum = 7;}
        if(duration===this.$t('14 days')){this.dayNum = 14;}
        if(duration===this.$t('30 days')){this.dayNum = 30;}
        if(duration===this.$t('90 days')){this.dayNum = 90;}
        if(duration===this.$t('Customize')){
          this.custo = true;
          this.st = this.et - 86400*6;
        }else{
          this.custo = false;
          this.st = this.et - 86400*(this.dayNum-1);
        }
        this.staTime = format.formatterDate4(this.st);
      },

      print(){
        let src1 = this.chart1_1.getDataURL();
        let src2 = this.chart1_2.getDataURL();
        let src3 = this.chart1_3.getDataURL();
        sessionStorage.setItem('src7_1',src1);
        sessionStorage.setItem('src7_2',src2);
        sessionStorage.setItem('src7_3',src3);
        sessionStorage.setItem('timeRange7',this.timeRange2);
        sessionStorage.setItem('targetH7',this.target_high);
        sessionStorage.setItem('targetL7',this.target_low);
        sessionStorage.setItem('sg7',JSON.stringify(this.sg));
        sessionStorage.setItem('count7',JSON.stringify(this.bolCount));
        sessionStorage.setItem('st7',this.st);
        sessionStorage.setItem('et7',this.et);
        window.open('/#/chart7-print','_blank');
      },
      openFullScreen(){
        this.loading = true;
      //   let t = 2000;
      //  if(this.dayNum>14){t=3000}
      //  if(this.dayNum>30){t=5000}
      //  if(this.dayNum>60){t=8000}
      //  //console.log(t);
      //   setTimeout(()=>{
      //     this.loading = false;
      //   },t);
      },
    },
    mounted: function () {
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      this.legend1Right =(win<1150)?-35:-30;
      this.legend2Right =(win<1150)?-43:-38;
      this.isEn = (sessionStorage.getItem('language')!=='zh')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.titleText = (this.isMg)?this.$t('SG')+' (mg/dL)':this.$t('SG')+' (mmol/L)';
      this.sgMax = (this.isMg)? 400:25;
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      if(!sessionStorage.getItem('st7')){
        //this.et= new Date().setHours(0,0,0,0)/1000-86400;
        var nd=new Date();
        var cur_day=new Date(nd.getFullYear(), nd.getMonth(), nd.getDate()-1)
        this.et=cur_day/1000;
        var chart_end_time=sessionStorage.getItem('chart_end_time')
        for (var d=0; d<3000; d++) {
          if (this.et > chart_end_time) {
            //this.et -= 24*3600;
            cur_day=new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate()-1)
            this.et=cur_day/1000;
          } else {
            break;
          }
        }
        this.st = this.et-86400*6;
      }else{
        this.st = parseInt(sessionStorage.getItem('st7'));
        this.et = parseInt(sessionStorage.getItem('et7'));
      }
      sessionStorage.setItem('st7',this.st);
      sessionStorage.setItem('et7',this.et);
      this.dayNum = (this.et-this.st)/86400+1;
      this.getDate();
      this.getData();
      let that = this;
      window.onresize = function () {
        that.handleResize();
        if(that.chart1_1){
          that.chart1_1.resize();
          that.chart1_2.resize();
          that.chart1_3.resize();
        }
      }
    },
  }
</script>

<style scoped>
  .chart-container {
    width: 100%;
    min-height:680px;
    float: left;
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.34px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }

  .main-header-right{
    float: right;
    width:80%;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
  .main-header-right p{
    float: right;
    margin-right:15px;
    margin-top:2px;
  }
  .main-header-right .time{
    font-size:16px;
    letter-spacing:-0.39px;
    color:#0082d2;
    margin-left: 10px;
  }
  .main-header-right button{
    float: right;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    background: #fff;
    border: 1px solid #a3a3a3;
    width:110px;
    height:26px;
    line-height: 26px;
    outline: none;
    margin-top:4px;
    margin-left: 3%;
    cursor: pointer;
  }
  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    color:#fff;
  }
  button span{
    font-family:SFUIText-Regular;
    font-size: 16px;
    letter-spacing:-0.39px;
  }
  .main-header-right .set{
    margin-left: 0;
  }
  .el-date-editor.el-input{
    width:125px;
  }

  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .spe-hr{
    margin-bottom:20px ;
  }
  .chart-container .graph{
    width:100%;
    height:170px;
    margin-bottom: 15px;
  }
   .bolCount{
     width:94%;
     height:30px;
     clear: both;
     margin:0 auto -26px;
  }
   .bolCount p{
     height: 15px;
   }
  .countLabel{
    width: 96%;
    height: 15px;
    margin-left: 1%;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .countLabel td{
    border:none;
    * border: 1px solid #ccc;
  }


  /*选择日期范围时样式*/
  .time-range p{
    margin: 0 18px 18px;
    margin-top: 2px;
  }
  .time-range button{
    float: right;
    margin-right: 2.2%;
  }
  /*对话框*/
  #dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }
  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:20px 0 10px 10px;
    border:none;
    clear: both;
  }
  .duration{
    margin-left: 20px;
    height:35px;
    line-height: 35px;
    margin-bottom: 20px;
  }
  .duration span{
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-left: 18px;
    margin-right: 15px;
  }
  .duration select{
    height: 30px;
    width: 120px;
    border-radius: 4px;
    padding-left: 10px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.44px;
  }
  .dialog-body .time-range{
    margin-left: 22px;
    height:35px;
    line-height: 35px;
    margin-bottom: 35px;
  }
  .time-range p{
    float: left;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-right: 25px;
  }
  .time-range .block{
    float: left;
  }
  .time-range .date{
    float: left;
    width:22%;
    height:40px;
    line-height: 40px;
    color:#282828;
    font-size: 16px;
    margin-right: 13%;
    margin-left: 14px;
  }
  .el-date-editor.el-input{
    width:125px;
  }

  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 7%;
  }
</style>



// WEBPACK FOOTER //
// chart7.vue?e5c26116